import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalDragService {
  makeDraggableByClass(className: string): void {
    const modals = document.querySelectorAll(`.${className}`);

    modals.forEach((modal) => {
      this.makeDraggable(modal as HTMLElement);
    });
  }

  private makeDraggable(elmnt: HTMLElement): void {
    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    const header = elmnt.querySelector('.modal-content') as HTMLElement;
    const dragTarget = header || elmnt;

    dragTarget.onmousedown = dragMouseDown;

    const self = this;

    function dragMouseDown(e: MouseEvent) {
      e.preventDefault();
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }

    function elementDrag(e: MouseEvent) {
      e.preventDefault();
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      elmnt.style.position = 'absolute';
      elmnt.style.top = (elmnt.offsetTop - pos2) + 'px';
      elmnt.style.left = (elmnt.offsetLeft - pos1) + 'px';
      elmnt.style.margin = '0'; // prevent bootstrap modal auto-center
    }

    function closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }
}
